// extracted by mini-css-extract-plugin
export default {"homeServiceCard":"HomeServiceCard_homeServiceCard__6Sc41","cardTitle":"HomeServiceCard_cardTitle__2rhIX","desc":"HomeServiceCard_desc__t0B99"};